import { useMemo } from "react";
import type { CSSProperties } from "react";
import { useScheduleContext } from "../context/useScheduleContext";
import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";
import { useIsTemplate } from "../useIsTemplate";
import { palette } from "../../../../Settings/Configuration/Schedule/Team/Settings/Shift/colors";
import { SCHEDULE_PREFERENCE_KEYS } from "../../constants/scheduleTypes";

export const useShiftPreferenceStyle = (event?: any) => {
    const { type } = useScheduleContext();
    const isTemplate = useIsTemplate();
    const preferences = usePreferences(SCHEDULE_PREFERENCE_KEYS[type]);

    return useMemo(() => {
        const caseDisplay = preferences?.shiftCaseDisplay || "normal";
        const textTransform = (caseDisplay === "normal" ? "none" : caseDisplay) as CSSProperties["textTransform"];

        if (event?.type === "unassigned") {
            return { textTransform, backgroundColor: "#ffffff", borderColor: "#f43f5e" };
        }

        let shiftColors;
        if (isTemplate) {
            shiftColors = palette?.regular?.[preferences?.colors?.regular ?? 0];
        } else if (event?.locked) {
            shiftColors = palette?.locked?.[preferences?.colors?.locked ?? 0];
        } else if (event?.status === "approved") {
            shiftColors = palette?.approved?.[preferences?.colors?.approved ?? 0];
        } else if (event?.status === "submitted") {
            shiftColors = palette?.submitted?.[preferences?.colors?.submitted ?? 0];
        } else {
            shiftColors = palette?.regular?.[preferences?.colors?.regular ?? 0];
        }

        return {
            textTransform,
            backgroundColor: shiftColors.bg,
            borderLeftColor: shiftColors.border,
        };
    }, [preferences, isTemplate, event?.locked, event?.status, event?.type]);
};
